import { useEffect, useState } from "react";
import { Autocomplete, FormControl } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { useTranslate } from "@/hooks";
import { selectEndpointList } from "@/store/ses/sesEndpointSlice";
import { ENDPOINT } from "@/constants/defaultValues";
import { colorPrimary } from "@/constants/colors";
import { IActionGoTo, IEndpoint } from "@/types/ses/sesItemConfigTypes";
import { CustomTextField } from "@/components/MUI";
import { NoOptionText } from "@/ui";
import { ISaveHandlerProps, IGoToProps } from "./GoTo.props";

const GoTo = ({ action, idx, channel, isDisabled, handleSaveActionInStore }: IGoToProps): JSX.Element => {
	const [inputEndpoint, setInputEndpoint] = useState<IEndpoint | null>(null); // КТ для поля endpoint действия togo

	const endpointList = useAppSelector(selectEndpointList); // список КТ

	const translate = useTranslate(); // hook для перевода текста

	useEffect(() => {
		const endpointFound = endpointList.data.find((endpointItem) => endpointItem.id === action.endpoint);
		setInputEndpoint(
			endpointFound ||
				(action.endpoint === ""
					? null
					: {
							...ENDPOINT,
							id: action.endpoint,
							name: `${action.endpoint} (${translate("title_notFound")})`,
					  })
		);
	}, []);

	// обработчик изменения КТ
	const handleEndpointChange = (_e: React.SyntheticEvent<Element, Event>, value: IEndpoint | null): void => {
		setInputEndpoint(value);
		action.endpoint !== (value?.id || "") && gotoActionDataChangeHandler({ endpoint: value?.id || "" });
	};

	// обработчик изменения данных действия "Принудительно перейти в КТ" (goto)
	const gotoActionDataChangeHandler = ({ endpoint }: Partial<ISaveHandlerProps>): void => {
		const data: { channel: string; idx: number; action: Partial<IActionGoTo> } = { channel, idx, action: { endpoint: endpoint ?? (inputEndpoint?.id || "") } };
		handleSaveActionInStore(data);
	};

	return (
		// КТ
		<FormControl fullWidth>
			<Autocomplete
				autoHighlight
				options={endpointList.data}
				value={inputEndpoint}
				onChange={handleEndpointChange}
				noOptionsText={<NoOptionText />}
				disabled={isDisabled}
				title={endpointList.dictionary[inputEndpoint?.id || ""] || inputEndpoint?.id}
				renderInput={(params) => <CustomTextField {...params} label={translate("select_endpoint")} error={!inputEndpoint} />}
				getOptionLabel={(option) => option.name}
				renderOption={(props, option) => {
					return (
						<span {...props} style={{ fontSize: 13, color: colorPrimary, textAlign: "left" }} key={option.id}>
							{option.name}
						</span>
					);
				}}
			/>
		</FormControl>
	);
};

export default GoTo;
